import ScrollMagic from 'scrollmagic';

export default function pinsProduct() {

    $(window).on('load', function () {

        if ($('.product-subheader').length > 0) {
            let controller = new ScrollMagic.Controller();

            new ScrollMagic.Scene({
                triggerElement: '.section-cart-promo',
                triggerHook: 0,
                offset: -112,
            })
                .setClassToggle('.product-subheader', '_active')
                .addTo(controller);
        }

        $('[data-scroll]').on('click', function () {
            $('html, body').animate({
                scrollTop: $('.tab-content').offset().top - 113
            }, 1000);
        });

    });
}